import { FooterAction, FooterCallToAction, FooterPromo, } from './components';
export var Footer;
(function (Footer) {
    Footer.Promo = FooterPromo;
    Footer.Action = FooterAction;
    Footer.CallToAction = FooterCallToAction;
})(Footer || (Footer = {}));
